import jQuery from 'js/sw-jquery/sw-jquery';

/**
 * VueJQueryMixin
 * Loads jQuery on the Vue instance.
 */
export default {
  beforeCreate() {
    this.$jQuery = jQuery;
  }
};
